export default __webpack_public_path__ + "static/media/Wilson Harry.7f2a53ae.png";